export default __webpack_public_path__ + "static/media/UMOWA.de5d0f8d.docx";